import React, { createContext, useContext, useState, useEffect } from 'react';
import { bool, node, object } from 'prop-types';

const ChatbotContext = createContext();

export const useChatbot = () => {
  const context = useContext(ChatbotContext);
  if (!context) {
    throw new Error('useChatbot must be used within a ChatbotProvider');
  }
  return context;
};

export const ChatbotProvider = ({ children, currentUser }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isEnabled, setIsEnabled] = useState(true);
  const [unreadCount, setUnreadCount] = useState(0);

  // Keep chatbot enabled for both guests and authenticated users.
  useEffect(() => {
    setIsEnabled(true);
  }, [currentUser]);

  const toggleChatbot = () => {
    if (isEnabled) {
      setIsOpen(prev => !prev);
      if (!isOpen) {
        // Reset unread count when opening
        setUnreadCount(0);
      }
    }
  };

  const closeChatbot = () => {
    setIsOpen(false);
  };

  const openChatbot = () => {
    if (isEnabled) {
      setIsOpen(true);
      setUnreadCount(0);
    }
  };

  const incrementUnreadCount = () => {
    if (!isOpen) {
      setUnreadCount(prev => prev + 1);
    }
  };

  const value = {
    isOpen,
    isEnabled,
    unreadCount,
    currentUser,
    toggleChatbot,
    closeChatbot,
    openChatbot,
    incrementUnreadCount,
  };

  return <ChatbotContext.Provider value={value}>{children}</ChatbotContext.Provider>;
};

ChatbotProvider.propTypes = {
  children: node.isRequired,
  currentUser: object,
};

export default ChatbotProvider;
